const categorias = [
  "Todos",
  "Exteriores",
  "Piscina",
  "Interiores",
  "Alrededores",
  "Videos",
];

export default categorias;
